import { components } from 'react-select';

export const customDropdownStyles = () => {
    return {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgb(255, 96, 31)" : "white",
            color: state.isFocused ? "white" : "black",
        }),
        control: (base) => {
            const isMobile = typeof window !== "undefined" && window.innerWidth < 500;
            return {
                ...base,
                borderColor: "rgb(255, 96, 31)",
                padding: "8px",
                "&:hover": {
                    borderColor: "rgb(255, 96, 31)",
                },
                boxShadow: "none",
                height: "37px",
                minHeight: "37px",
                alignContent: "center",
                width: isMobile ? "200px" : "269px",
                fontSize: isMobile ? "smaller" : "13px"
            }
        },
        input: (base) => ({
            ...base,
            textAlign: 'left',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: "rgb(255, 96, 31)",
            "&:hover": {
                color: "rgb(255, 96, 31)",
            },
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: "150px",
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        })
    };
};

export const customMultiDropdownStyles = () => {
    return {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgb(255, 96, 31)" : "white",
            color: state.isFocused ? "white" : "black",
        }),
        control: (base) => {
            const isMobile = typeof window !== "undefined" && window.innerWidth < 500;
            return {
                ...base,
                borderColor: "rgb(255, 96, 31)",
                "&:hover": {
                    borderColor: "rgb(255, 96, 31)",
                },
                boxShadow: "none",
                height: "37px",
                minHeight: '37px',
                alignContent: "center",
                width: isMobile ? "200px" : "269px",
                fontSize: isMobile ? "smaller" : "15px"
            }
        },
        input: (base) => ({
            ...base,
            textAlign: 'left',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: "rgb(255, 96, 31)",
            "&:hover": {
                color: "rgb(255, 96, 31)",
            },
        }),
        menuList: (base) => ({
            ...base,
            // maxHeight: "150px",
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        })
    }
};

export const CheckboxMultiSelectOption = (props) => (
    <components.Option {...props}>
        <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            style={{ marginRight: 8 }}
        />
        {props.label}
    </components.Option>
);

export const MultiValue = () => null;

export const MultiValueCount = (props) => {

    const selected = props.getValue();
    const displayLabel = selected.length > 0 ? selected[0].label : '';
    const count = selected.length;

    return (
        <components.ValueContainer {...props}>
            {count > 0 && (
                <div style={{ marginRight: 2 }}>
                    {displayLabel} {count > 1 ? `+${count - 1} more` : ''}
                </div>
            )}
            {props.children}
        </components.ValueContainer>
    );
};

export const customCheckboxMultiSelect = {
    option: (provided, state) => ({
        ...provided,
        // backgroundColor: state.isFocused ? 'rgb(255, 96, 31)' : 'white',

        backgroundColor: state.isSelected
            ? 'rgb(255, 96, 31)'
            : state.isFocused
                ? 'rgb(255 182 153)'
                : 'white',
        color: (state.isFocused || state.isSelected) ? 'white' : 'black',
    }),
    control: (base) => {
        const isMobile = typeof window !== 'undefined' && window.innerWidth < 500;
        return {
            ...base,
            borderColor: 'rgb(255, 96, 31)',
            padding: '8px',
            '&:hover': {
                borderColor: 'rgb(255, 96, 31)',
            },
            boxShadow: 'none',
            height: '37px',
            minHeight: '37px',
            alignContent: 'center',
            width: isMobile ? '200px' : '269px',
            fontSize: isMobile ? 'smaller' : '13px',
        };
    },
    input: (base) => ({
        ...base,
        textAlign: 'left',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: 'rgb(255, 96, 31)',
        '&:hover': {
            color: 'rgb(255, 96, 31)',
        },
    }),
    menuList: (base) => ({
        ...base,
        // maxHeight: '150px',
        zIndex: 9999,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
    }),
};